export default "__VITE_ASSET__CBViVouJ__"